import { TableDomain } from "_components/Abstractions/TableDomain";

export function ExternalWeighingContractorTable({ items, onSelect, multiSelect = false, onSelectedItemsChanged, selectedItems = [] }) {
  const keyColumn = "id";
  const columns = [
    {
      name: "name",
      headerName: "Nazwa 1",
    },
    {
      name: "additionalName",
      headerName: "Nazwa 2",
    },
    {
      name: "taxId",
      headerName: "NIP",
    },
    {
      headerName: "Adres",
      map: (item) => [item.street, item.postalCode, item.city].filter(Boolean).join(", "),
    },
  ];

  const props = {
    keyColumn,
    columns,
    items,
    onSelect,
    selectable: true,
    multiSelect,
    onSelectedItemsChanged,
    selectedItems,
  };

  return (
    <>
      <TableDomain {...props}></TableDomain>
    </>
  );
}
